var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDiscard = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 26.6667C5.96953 26.6667 0 20.6971 0 13.3333C0 5.96953 5.96953 0 13.3333 0C20.6971 0 26.6667 5.96953 26.6667 13.3333C26.6667 20.6971 20.6971 26.6667 13.3333 26.6667ZM13.3333 11.4477L9.56209 7.67648L7.67648 9.56209L11.4477 13.3333L7.67648 17.1045L9.56209 18.9901L13.3333 15.2189L17.1045 18.9901L18.9901 17.1045L15.2189 13.3333L18.9901 9.56209L17.1045 7.67648L13.3333 11.4477Z",
    fill: "#7F2E00"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDiscard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Discard.9d627a39.svg";
export { ForwardRef as ReactComponent };